import { ApplicationSubtype, RecognitionKind, SelectFormField } from "@duosoftbg/nacid-components";
import { useWatch } from "react-hook-form";
import React from "react";
import { useTranslation } from "react-i18next";

const SeRecognitionKindFormFields = () => {
  const { t } = useTranslation();
  const applicationSubtype = useWatch({ name: "applicationSubtype" });

  if (applicationSubtype !== ApplicationSubtype.SE_RECOGNITION.valueOf()) {
    return null;
  }

  return (
    <SelectFormField
      fieldName={"seRecognitionKind"}
      labelCode={"l.filter.seRecognitionKind"}
      addEmptyOption={false}
      selectOptions={[
        { value: null, text: "-" },
        ...Object.values(RecognitionKind).map((kind) => ({
          value: kind,
          text: t("t.seRecognition." + kind.valueOf()),
        })),
      ]}
    />
  );
};
export default SeRecognitionKindFormFields;
